export const EVENT_COLOR_CLICKED = 'EVENT_COLOR_CLICKED'
